<div style="transition: max-height 1s ease-in-out;" [ngClass]="{'display-whole-section':open}">

  <app-item-base [open]="open"></app-item-base>

  <app-item-keyword [searchParams]="searchParams" [open]="open&&showSkillSearch" (newSearch)="newRequest()"></app-item-keyword>

  <app-item-required-skills [searchParams]="searchParams" [open]="open&&showSkillSearch" [allSkills]="allSkills" (newSearch)="newRequest()"></app-item-required-skills>

  <div (change)="newRequest()">

    <app-item-fee [searchParams]="searchParams" [open]="open || valueChanged('fee_from')||valueChanged('fee_to')"></app-item-fee>

    <app-item-gross-margin [searchParams]="searchParams" [open]="open || valueChanged('gross_margin_setting')"[page]="page"></app-item-gross-margin>

    <app-item-age [searchParams]="searchParams" [open]="open || valueChanged('age_from')||valueChanged('age_to')"></app-item-age>

    <app-item-location [searchParams]="searchParams" [open]="open || valueChanged('work_location')"></app-item-location>

    <app-item-commute [searchParams]="searchParams" [open]="open || valueChanged('commute_location')||valueChanged('commute_time')"></app-item-commute>

    <app-item-mail-from [searchParams]="searchParams" [open]="open || valueChanged('mail_from')"></app-item-mail-from>

    <app-item-bp-rank [searchParams]="searchParams" [open]="open || valueChanged('bp_rank')"></app-item-bp-rank>

    <app-item-number-of-connect-company [searchParams]="searchParams"
      [open]="open || valueChanged('number_of_connect_company') || valueChanged('number_of_connect_company_null')" [forWorker]="forWorker">
    </app-item-number-of-connect-company>

    <app-item-employment-status [searchParams]="searchParams"
      [open]="open || valueChanged('employment_status') || valueChanged('employment_status_null')" [forWorker]="forWorker">
    </app-item-employment-status>

    <app-item-country-of-citizenship [searchParams]="searchParams"
      [open]="open || valueChanged('country_of_citizenship') || valueChanged('country_of_citizenship_null')" [forWorker]="forWorker">
    </app-item-country-of-citizenship>

    <app-item-begin-at [searchParams]="searchParams"
      [open]="open || valueChanged('begin_from') || valueChanged('begin_to') || valueChanged('begin_null')">
    </app-item-begin-at>

    <app-item-interview-times [searchParams]="searchParams"
      [open]="open || valueChanged('interview_times') || valueChanged('interview_times_null')" [forWorker]="forWorker">
    </app-item-interview-times>

    <app-item-receipt-datetime [searchParams]="searchParams" [open]="open || valueChanged('receipt_datetime')"></app-item-receipt-datetime>

  </div>
</div>
